import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpsellAdData } from "gql/graphql";

export type UpsellAdDataState = {
  healthReportUpsell: null | UpsellAdData;
};

const initialState: UpsellAdDataState = {
  healthReportUpsell: null,
};

const upsellAdDataSlice = createSlice({
  name: "upsellAdData",
  initialState,
  reducers: {
    setUpsellAdData(state, action: PayloadAction<UpsellAdDataState>) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setUpsellAdData } = upsellAdDataSlice.actions;

export default upsellAdDataSlice;
